import { render, staticRenderFns } from "./BoardWriteCategoryLayout.vue?vue&type=template&id=1ebff28e&scoped=true&"
import script from "./BoardWriteCategoryLayout.vue?vue&type=script&lang=js&"
export * from "./BoardWriteCategoryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebff28e",
  null
  
)

export default component.exports